// extracted by mini-css-extract-plugin
module.exports = {"tabbedNav":"tabRaceDetail_tabbedNav__jZjfC","selected":"tabRaceDetail_selected__21Zys","inputs":"tabRaceDetail_inputs__3WjRC"};